import styled from 'styled-components'

export const ReturnButtonWrapper = styled.div`
  @media (max-width: 768px) {
    flex: 1 1;
    
    button {
      width: 100%;
    }
  }
`
